import { withStyles } from '@material-ui/core';
import GCPaymentOption from './GCPaymentOption';
import styles from './GCPaymentOption.styles';

export default withStyles(styles)(GCPaymentOption);
